import { useEffect, useState } from 'react';

export function useScheduleBreakpointMobile() {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(max-width: 991.98px)').matches : false
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 991.98px)');
    const handler = () => setIsMobile(mq.matches);
    mq.addEventListener('change', handler);
    setIsMobile(mq.matches);
    return () => mq.removeEventListener('change', handler);
  }, []);
  return isMobile;
}

export const isScheduleHistoryKeyTarget = (target: EventTarget | null) => {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (target.isContentEditable) return true;
  return false;
};

export function isScheduleToolbarFilterTarget(target: EventTarget | null): boolean {
  return target instanceof HTMLElement && Boolean(target.closest('.schedule-toolbar .holder-select'));
}

export function blurScheduleToolbarFilters(): void {
  const active = document.activeElement;
  if (active instanceof HTMLElement && isScheduleToolbarFilterTarget(active)) {
    active.blur();
    return;
  }
  const toolbar = document.querySelector('.schedule-toolbar');
  const focusedInput = toolbar?.querySelector<HTMLElement>('.holder-select input:focus');
  focusedInput?.blur();
}

export function isScheduleToolbarFilterFocused(): boolean {
  return isScheduleToolbarFilterTarget(document.activeElement);
}

export function dismissScheduleToolbarFilterOnEscape(e: KeyboardEvent): boolean {
  if (e.key !== 'Escape' || !isScheduleToolbarFilterFocused()) return false;
  blurScheduleToolbarFilters();
  e.preventDefault();
  e.stopPropagation();
  return true;
}

export const SCHEDULE_ZOOM_COLUMN_WIDTH_STEP = 10;

export const isScheduleZoomInKey = (e: KeyboardEvent) =>
  ['+', '='].includes(e.key) || ['Equal', 'NumpadAdd'].includes(e.code);

export const isScheduleZoomOutKey = (e: KeyboardEvent) =>
  ['-', '_'].includes(e.key) || ['Minus', 'NumpadSubtract'].includes(e.code);

export function isScheduleOpenShortcutsKey(e: KeyboardEvent): boolean {
  if (e.ctrlKey || e.metaKey || e.altKey) return false;
  if (e.key === '?') return true;
  if (e.shiftKey && (e.key === '/' || e.code === 'Slash')) return true;
  return false;
}
